<template>
  <button
    class="w-full border-4 rounded-full border-dashed h-10"
    v-bind="$attrs"
  >
    <div class="flex flex-row items-center justify-center">
      <plus-icn
        width="20px"
        height="20px"
        class="mr-1"
        :class="`${color}-icon`"
      ></plus-icn>
      <div>
        <slot></slot>
      </div>
    </div>
  </button>
</template>

<script>
import PlusIcn from '@/assets/icons/plus.svg?inline'

export default {
  name: 'AppButtonCreate',

  components: {
    PlusIcn,
  },

  props: {
    color: String,
  },
}
</script>
